var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', _vm._g(_vm._b({
    class: _vm.classes,
    attrs: {
      "disabled": _vm.isLoading || _vm.disabled,
      "type": _vm.type
    }
  }, 'button', _vm.$attrs, false), _vm.$listeners), [_vm.isLoading ? _c('i', {
    staticClass: "fas fa-spinner fa-spin"
  }) : _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }